<template>
  <div @click="onFirstClick">
    <BaseDropdown
      :buttonClasses="buttonClasses"
      :onDialogChange="onChange"
      buttonTitle="Method #2"
      :isOpen="openDialog">
      <div class="card m-0 p-3 is-flex max-width-dropdown">
        <div class="control is-flex is-flex-wrap-wrap tags">
          <label
            v-for="skill in skills"
            :key="skill.text"
            class="radio same-size mx-1">
            <input type="radio" name="skills" :value="skill.value" hidden />
            <span class="tag is-link full-width">{{ skill.text }}</span>
          </label>
        </div>
      </div>
    </BaseDropdown>
  </div>
</template>
<script>
import BaseDropdown from '@/components/BaseDropdown'

export default {
  name: 'DataTableMethodTwo',
  components: {
    BaseDropdown
  },
  props: {
    applicantId: {
      type: [Number, String]
    }
  },
  data () {
    return {
      skills: []
    }
  },
  computed: {
    buttonClasses () {
      const info = this.$route.query.m == '2' ? 'is-info' : ''
      return `unique_button button margin-right ${info}`
    },
    openDialog () {
      return this.$route.query.o == 'true'
    }
  },
  created () {
    this.$network_utils
      .getApplicantSkills({ current_applicant_id: this.applicantId })
      .then((response) => {
        this.skills = response
          .filter((skill) => skill.skill.featured)
          .map((skill) => {
            return {
              text: skill.skill.name,
              value: skill.skill.id
            }
          })
      })
  },
  methods: {
    onChange (e) {
      const params = { ...this.$route.query }
      delete params.o
      const query = { ...params, skills: e.target.value }
      this.$router.push({ name: 'applicant-offers', query })
    },
    onFirstClick () {
      const query = {
        sort: '-sent_at',
        applicant_id: this.$route.query.applicant_id,
        m: 2,
        o: 'true',
        is_hot_positions: 'true'
      }
      this.$router.push({ name: 'applicant-offers', query }).catch((err) => {
        console.error('Navigation error:', err)
      })
    }
  }
}
</script>

<style scoped>
.max-width-dropdown {
  max-width: 600px;
}
.margin-right {
  margin-right: 10px;
}
.same-size {
  margin-left: 0;
  flex: 1 1 0px;
}
.full-width {
  width: 100%;
}
</style>
